module.exports = __webpack_public_path__ + "static/media/messenger2.2d18d325.svg";